import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register, formatError } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(email.trim(), password, name.trim());
      toast.success("Welcome to the dex.");
      navigate("/");
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-8 py-14">
      <h1 className="font-display text-5xl tracking-tighter mb-2">join the dex<span className="text-hot">.</span></h1>
      <p className="font-mono-tag text-xs uppercase mb-6">submit & track your own slang</p>

      <form onSubmit={onSubmit} className="bg-white brutal p-6 space-y-4">
        <div>
          <label className="font-mono-tag text-[10px] uppercase block mb-1">handle / name</label>
          <input data-testid="register-name-input" value={name} onChange={(e) => setName(e.target.value)} required minLength={1}
            className="w-full px-3 py-2 brutal-sm bg-white focus:outline-none font-display" />
        </div>
        <div>
          <label className="font-mono-tag text-[10px] uppercase block mb-1">email</label>
          <input data-testid="register-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="w-full px-3 py-2 brutal-sm bg-white focus:outline-none font-display" />
        </div>
        <div>
          <label className="font-mono-tag text-[10px] uppercase block mb-1">password (6+ chars)</label>
          <input data-testid="register-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6}
            className="w-full px-3 py-2 brutal-sm bg-white focus:outline-none font-display" />
        </div>

        {error && <p data-testid="register-error" className="bg-hot text-white brutal-sm px-3 py-2 font-mono-tag text-xs uppercase">{error}</p>}

        <button data-testid="register-submit-btn" type="submit" disabled={loading}
          className="w-full bg-lime font-display uppercase py-3 brutal-sm brutal-hover brutal-active disabled:opacity-60">
          {loading ? "..." : "Create account"}
        </button>
      </form>

      <p className="mt-4 font-mono-tag text-xs uppercase">
        have one? <Link data-testid="link-to-login" to="/login" className="underline decoration-2">log in</Link>
      </p>
    </div>
  );
}
